import React from "react";
import { writeValueInsideBar } from "../utils/BarLabelUtils"
import { updateViewBox } from "../utils/UpdateViebox";
import { localizeValue } from "../utils/Labels";
import { verticalChartOptions, horizontalChartOptions } from "./utils/orientationChartOptions";
import ChartistGraph from "../ChartistGraph/ChartistGraph";
import { Svg } from "chartist";
import Tooltip from "@bge/chartist_custom_plugins/dist/es/tooltip/chartist-plugin-tooltip-custom";


const BarChart = (props) => {
  const { labels = [], series = [], chartClassName = "ct-double-octave", options = {}, locale, verticalOrientation = false} = props;

  let chartSeries = [];

  const reverse = options.reverseData;
  
  for (let i = 0; i < series.length; i++) {
    let chartSerie = [];
    for (let j = 0; j < series[i].length; j++) {
      let labelPos = j;
      if (reverse) labelPos = labels.length-j-1;
      chartSerie.push({meta: labels[labelPos], value:series[i][j]});
    }
    chartSeries.push(chartSerie);
  }

  const data = {
    labels: labels,
    series: chartSeries
  };

  const {prefix = "", suffix = ""} = options;

  let labelTransformFn = null;
  if(options.transform)
    labelTransformFn = options.transform.labels;
    
  let orientationChartOptions = verticalOrientation ? verticalChartOptions : horizontalChartOptions;

  const listener = {
    created: function (data) {
      updateViewBox(data);
    },
    draw: function (data) {
      writeValueInsideBar(data, locale, prefix, suffix, labelTransformFn, verticalOrientation);
      if (data.type === 'bar') {
        const value = data.value.y ? data.value.y : data.value.x;
        data.group.append(new Svg('line', {
          y1: data.y1,
          y2: data.y2,
          x1: data.x1,
          x2: data.x2,
          'ct:value': `${value}`,
          'ct:meta': data.meta
        }, 'ct-bar ct-bar-over'));
      }
    }
  }

  const chartOptions = {
    ...orientationChartOptions,
    ...options
  };

  const plugins = [
    Tooltip({
      appendToBody: true, 
      appendToPoint: true,
      tooltipFnc: (meta, value) => `${meta} <br> <p class="value-text">${prefix}${value}${suffix}</p>`,
      transformTooltipTextFnc: (value) => labelTransformFn ? labelTransformFn(value, locale) :  localizeValue(value, locale)
    })
  ]

  const verticalChartClassName = verticalOrientation ? " vertical-bar-chart " : " horizontal-bar-chart "; 
  return (
    <ChartistGraph 
      data={data} 
      options={{...chartOptions, plugins}} 
      type="Bar" 
      className={"bar-chart " + chartClassName + verticalChartClassName}
      listener={listener}
    />
  );
};

export default BarChart;